import { TypedEpic } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/empty';

import { addMatchId, clearMatchIds } from './actions';
import { ADD_NEAREST_MATCH_ID } from './constants';
import {
    selectLiveMatchesByIds,
    selectMatchIdsWithOpenedStream,
} from './selectors';

export const openInitialLiveMatch: TypedEpic = (action$, store) => {
    return action$.ofType(ADD_NEAREST_MATCH_ID).switchMap(action => {
        const { matchIds } = action.payload;
        const state = store.getState();
        const matchIdsWithOpenedStream = selectMatchIdsWithOpenedStream(state);

        const isEmpty = matchIdsWithOpenedStream.intersect(matchIds).isEmpty();

        if (!isEmpty) return Observable.empty();

        const liveMatchIds = selectLiveMatchesByIds(state, {
            matchIds,
        });
        const firstLiveMatchId = liveMatchIds[0];

        if (!firstLiveMatchId) return Observable.of(clearMatchIds());

        return Observable.of(
            addMatchId({ matchId: firstLiveMatchId, withClearPrev: true })
        );
    });
};
